import React, { useState, useEffect } from "react";
import { Button, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import iconDiem from "../../../../assets/images/Event-2025/icon-diem-event.png";
// import iconTiaLua from "../../../../assets/images/event-2024/icon-tia-lua.png";
import { useBid, getRemainTurnQuery } from "@dataLayer/user";
import BitelModal, { ModalChoosePack } from "@components/Modal";
import { currentDate } from "@utils/utils";
import PackSuccess from "@pages/Events/NewYearAndChristmas_2024/Components/animtion/PackSuccess";
import PopupCompleteMission from "@pages/Events/MiniGame/components/PopupFooter/PopupCompleteMission";

const { Text } = Typography;

const PlaceBidForm = ({ product }) => {
  const ONLY_NUMBER = /^(0|[1-9]\d*)(\.\d+)?$/;
  const isUpcomingBidNow =
    new Date(product?.start_time).getTime() > currentDate;

  const { t } = useTranslation();
  const { data, isLoading, mutate } = useBid();
  const { data: currentPack } = useQuery(getRemainTurnQuery());
  const [displayModal, setDisplayModal] = useState(false);
  const [price, setPrice] = useState(null);
  const [inputError, setInputError] = useState(false);
  const [focused, setFocused] = useState(false);
  const [isSuccessBid, setIsSuccessBid] = useState(false)

  const [showMinigamePopup, setShowMinigamePopup] = useState(false);
  const [minigameRewardData, setMinigameRewardData] = useState(null);

  const [pendingMissionReward, setPendingMissionReward] = useState(null);
  const [showBitelModal, setShowBitelModal] = useState(false);  

  const turnCount = currentPack?.reduce((acc, pack) => {
    return acc + pack?.turn;
  }, 0);
  const bidTotal = currentPack?.reduce((acc, pack) => {
    return acc + pack?.turn;
  }, 0);
  const packagePackLength = currentPack?.filter((pack) => pack?.type === 1);

  const handleBid = () => {
    if (turnCount > 0) {
      mutate({ price, productCode: product.product_code });
    } else {
      setDisplayModal(true);
    }
  };

  const onChangePrice = (e) => {
    let priceFormatted = e.target.value;
    if (parseFloat(priceFormatted) > 1000000) {
      priceFormatted = "1000000";
      setPrice(priceFormatted);
    }
    if (priceFormatted.indexOf(".") !== -1) {
      if (
        priceFormatted.substring(priceFormatted.length - 2).indexOf(".") === -1
      ) {
        priceFormatted = `${priceFormatted.split(".")[0]}.${priceFormatted
          .split(".")[1]
          .slice(0, 1)}`;
        setPrice(priceFormatted);
      } else {
        setPrice(priceFormatted);
      }
    } else {
      setPrice(priceFormatted);
    }
  };

  const handleFocus = () => {
    setFocused(false);
  };

  useEffect(() => {
    if (price?.toString()?.match(ONLY_NUMBER)) {
      setInputError(false);
    } else setInputError(true);
  }, [price]);

  useEffect(() => {
    if (data?.data?.errorCode == 0) {
      setIsSuccessBid(true);
      setPrice(null);

      const bidResult = data?.data; 

      setShowBitelModal(true);

      if (bidResult?.reelAddNormal > 0 || bidResult?.reelAddSuper > 0) {
        setPendingMissionReward(bidResult);
      }
    } else {
      setIsSuccessBid(false);
    }
  }, [data]);

  const handleCloseBitelModal = () => {
    setShowBitelModal(false);
    
    if (pendingMissionReward) {
      setMinigameRewardData(pendingMissionReward);
      setShowMinigamePopup(true);
      setPendingMissionReward(null);
    }
  };  

  const handleClose = () => setDisplayModal(false);

  return (
    <>
      <PopupCompleteMission
        visible={showMinigamePopup}
        setVisible={setShowMinigamePopup}
        data={minigameRewardData}
      />      
      <PackSuccess isSuccessSubPack={isSuccessBid} icon={iconDiem} />
      <Input.Group compact className="page-block-form">
        {turnCount > 0 &&
        new Date(product?.start_time).getTime() < currentDate ? (
          <div
            className={`page-block-form-input ${
              inputError && price != null ? "error-outline" : ""
            }`}
          >
            {/* <InputNumber
              className="page-block-form-input-bid"
              formatter={(value) =>
                `${t("currency_sign")} ${value}`.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  ","
                )
              }
              parser={(value) => {
                // eslint-disable-next-line
                const regex = new RegExp(`${t("currency_sign")}\s?|(,*)`, "g");
                const newValue = value.replace(regex, "");
                return parseFloat(newValue).toFixed(1);
              }}
              value={price}
              min={0.1}
              max={1000000}
              step="0.1"
              controls={false}
              autoFocus={true}
              onChange={onChangePrice}
              status={
                !price?.toString()?.match(ONLY_NUMBER) ? "error" : inputError
              }
            /> */}
            <label htmlFor="bid-input" />
            <span className="page-block-form-input-currency">
              {t("currency_sign")}
            </span>
            <input
              className="page-block-form-input-bid"
              type="text"
              inputMode="decimal"
              // min="0.1"
              // max="1000000"
              value={price}
              onChange={onChangePrice}
              onBlur={handleFocus}
              onFocus={() => setFocused(true)}
              id="bid-input"
              onKeyDown={(e) => {
                if (
                  e.key !== "1" &&
                  e.key !== "2" &&
                  e.key !== "3" &&
                  e.key !== "4" &&
                  e.key !== "5" &&
                  e.key !== "6" &&
                  e.key !== "7" &&
                  e.key !== "8" &&
                  e.key !== "9" &&
                  e.key !== "0" &&
                  e.key !== "Backspace" &&
                  e.key !== "."
                )
                  e.preventDefault();
              }}
              onPaste={(e) => e.preventDefault()}
              onDrop={(e) => e.preventDefault()}
              required
            />
          </div>
        ) : null}
        <Button
          type="primary"
          onClick={handleBid}
          className="page-block-form-button"
          style={
            isUpcomingBidNow ? { marginLeft: "0" } : { marginLeft: "10px" }
          }
          loading={isLoading}
          disabled={isUpcomingBidNow}
        >
          {t("product.place_a_bid")}
        </Button>
      </Input.Group>
      {inputError && focused && price != null && price !== "" ? (
        <Text className="page-block-form-input-error">
          {t("error.invalid_value")}
        </Text>
      ) : null}
      {price === "" && focused ? (
        <Text className="page-block-form-input-error">
          {t("error.empty_value")}
        </Text>
      ) : null}
      {turnCount > 0 && (
        <div style={{ width: "min(100%, 382px)" }}>
          <Text className="page-block-form-input-explain">
            Escribe aquí la oferta/puja <b>más baja y única</b> que creas
            conveniente para ganarte el premio.
          </Text>
          <br />
          <Text className="page-block-form-input-explain">
            {t("product.explain.last")}
          </Text>
        </div>
      )}
      <BitelModal
        visible={showBitelModal}
        onClose={handleCloseBitelModal}      
        data={data?.data}
        error={
          data?.errorMessage ? t("error.invalid_value") : data?.errorMessage
        }
        defaultMsg={t("error.bid")}
      />
      <ModalChoosePack
        visible={displayModal}
        title={t("bid.buy_subscription")}
        handleClose={handleClose}
        bidTotal={bidTotal}
        packagePackLength={packagePackLength}
      />
    </>
  );
};

export default PlaceBidForm;
